import { useQuery } from '@tanstack/react-query';

export const TEAM_URL = `${import.meta.env.VITE_AUTH_DOMAIN || ''}/api/v1/team/list/`;

export const fetchTeamList = async () => {
  try {
    const response = await fetch(TEAM_URL);
    if (!response.ok) {
      console.warn(`Server returned ${response.status}. Returning empty list.`);
      return { data: [] }; // Match the expected Django response shape
    }
    return await response.json();
  }
  catch (error) {
    console.error('Network error:', error);
    return { data: [] }; // Return empty array on network failure
  }
};

export const useGetTeamList = (setTeam) => {
  return useQuery({
    // A unique key for this query
    queryKey: ['teamList'],
    // The function that fetches the data
    queryFn: fetchTeamList,
    // Refetch data only once every hour (optional, but good for static data)
    staleTime: 1000 * 60 * 60,
    // On successful fetch, update the global state variables
    onSuccess: (responseData) => {
      // Note: You might want to remove setTeam entirely and rely only on data
      // For now, we keep it to maintain compatibility with other components
      if (setTeam) {
        setTeam(responseData.data);
      }
    },
  });
};
